<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useTaskCreationHeader } from '../../model/creation/task-creation-header.hook'

defineOptions({
  name: 'TaskCreationHeader',
})

const {
  config,
} = useTaskCreationHeader()

</script>

<template>
  <NavigationBreadcrumbs
    :config="config"
  />
</template>
